import React, { useEffect, useRef } from "react";
import { MdArrowOutward } from "react-icons/md";
import { useStateContext } from "../../context/ContextProvider";

const ServicesSection = ({
  service,
  index,
  setActiveService
}) => {
  const {
    isMobile
  } = useStateContext();
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActiveService(index);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [index, setActiveService]);

  const {
    heading,
    text, 
    img, 
    categories, 
    isActive, 
    flip
  } = service;

  return (
    <div
    ref={sectionRef}
      onMouseEnter={() => setActiveService(index)}
      className={`w-9/12 lg:w-4/5 py-4`}>
      <div className="grid grid-cols-5 gap-5">
        {/* CONTENT */}
        <div
          className={`order-2 ${flip ? "md:order-2" : "md:order-1"
            } col-span-5 md:col-span-3`}
        >
          <div className="flex flex-col text-white text-center md:text-start gap-2">
            <div className="flex justify-center md:justify-start gap-[5px]">
              <span className="w-fit text-2xl md:text-3xl lg:text-4xl font-bold">
                {heading}
              </span>
              <MdArrowOutward size={isMobile ? 30 : 50} color="var(--primary)" />
            </div>
            <p className="text-white text-sm font-light text-center md:text-left">
              {text}
            </p>
            <div className="flex flex-col flex-wrap items-center md:flex-row md:items-start gap-2 my-3">
              {categories?.map((cat) => (
                <p className="border border-white text-white text-nowrap text-sm text-center bg-transparent rounded-full px-3 py-2 mb-2 md:mb-0">
                  {cat}
                </p>
              ))}
            </div>
          </div>
        </div>
        {/* IMAGE */}
        <div
          className={`order-1 ${flip ? "md:order-1" : "md:order-2"
            } col-span-5 md:col-span-2`}
        >
          <div className="flex justify-center">
            <img
              src={img}
              alt="DoDeal Services"
              className={`${isActive ? "border-[10px] border-[var(--primary)] rounded-full" : ""} rounded-full w-full max-w-48 aspect-square`}
            />
          </div>
        </div>
      </div>

    </div>
  );
};

export default ServicesSection;
